import {Injectable, Inject} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {OperatorLockItem} from '@emm/core/models/operator-lock-item.model';
import {standardRetry} from '@emm/core/util/rx.util';
import {Item} from '@emm/core/models/item.model';

@Injectable({
    providedIn: 'root',
})
export class LockItemService {
    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {
    }

    public getItemsByEmergency(emergency: string): Observable<OperatorLockItem[]> {
        return this.http
            .get<{ _embedded: { emergencyMappings: OperatorLockItem[] } }>(
                `${this.apiUrl}/emergencies/mapping/${emergency}/items`
            )
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }

    public addEmergencyItems(emergencyTag: string, items: Item[]): Observable<any> {
        const itemTags: any[] = [];
        // console.log('Emergency-item' + items);

        items.forEach((item: Item) => {
            itemTags.push({
                tag: item.tag,
            });
        });

        return this.http
            .post(`${this.apiUrl}/emergencies/${emergencyTag}`, itemTags)
            .pipe(standardRetry());
    }

    public uploadOperatorLockItems(emergencyTag: string, file: FormData): Observable<any> {
        return this.http
            .post(`${this.apiUrl}/emergencies/${emergencyTag}/items/upload`, file)
            .pipe(standardRetry());
    }

    public deleteEmergencyItem(emergencyTag: string, itemTag: string): Observable<any> {
        return this.http
            .delete(`${this.apiUrl}/emergencies/${emergencyTag}/${itemTag}`)
            .pipe(standardRetry());
    }

    public downloadSampleFile(): Observable<HttpResponse<Blob>> {
        return this.http
            .get<Blob>(`${this.apiUrl}/emergencies/items/sample/download`,
                {observe: 'response', responseType: 'blob' as 'json'});
    }
}
